var a = Object.defineProperty;
var g = (l, t, i) => t in l ? a(l, t, { enumerable: !0, configurable: !0, writable: !0, value: i }) : l[t] = i;
var h = (l, t, i) => (g(l, typeof t != "symbol" ? t + "" : t, i), i);
class c {
  constructor(t, i, o, e, s, r) {
    h(this, "samples");
    h(this, "waveform_canvas");
    h(this, "width");
    h(this, "height");
    h(this, "fillColor");
    h(this, "strokeColor");
    h(this, "progressColor");
    h(this, "highlightColor");
    this.samples = i, this.waveform_canvas = t, this.width = t.width, this.height = t.height, this.fillColor = o, this.strokeColor = e, this.progressColor = s, this.highlightColor = r;
  }
  getNormalizationFactor() {
    return this.height / (2 * 128);
  }
  drawWaveform() {
    const t = this.waveform_canvas.getContext("2d");
    t.globalCompositeOperation = "source-over", t.strokeStyle = this.strokeColor || "rgb(65,65,65)", t.fillStyle = this.fillColor || "rgb(95, 95, 95)", t.beginPath(), t.moveTo(0, this.height / 2), t.lineTo(this.width, this.height / 2), t.stroke();
    let i = 0;
    const o = 1, e = -1 * this.getNormalizationFactor();
    t.beginPath(), t.moveTo(0, this.height / 2);
    for (let s = 0; s < this.samples.length; s += 2 * o)
      i += o, t.lineTo(i, this.height / 2 + e * this.samples[s]);
    for (let s = this.samples.length - 1; s > 0; s -= 2 * o)
      i -= o, t.lineTo(i, this.height / 2 + e * this.samples[s]);
    t.stroke(), t.fill();
  }
  drawProgress(t) {
    this.clearProgress();
    const i = this.waveform_canvas.getContext("2d");
    i.globalCompositeOperation = "source-atop", i.fillStyle = this.progressColor, i.fillRect(0, 0, this.width * t, this.height);
  }
  drawHighlight(t, i) {
    this.clearProgress();
    const o = this.waveform_canvas.getContext("2d");
    o.globalCompositeOperation = "source-atop", o.fillStyle = this.highlightColor, o.fillRect(t, 0, i, this.height);
  }
  drawBoth({ start: t, end: i, progress: o }) {
    this.clearProgress();
    const e = this.waveform_canvas.getContext("2d");
    e.globalCompositeOperation = "source-atop", t !== void 0 && i !== void 0 && (e.fillStyle = this.highlightColor, e.fillRect(t, 0, i, this.height)), o !== void 0 && (e.fillStyle = this.progressColor, e.fillRect(0, 0, this.width * o, this.height));
  }
  clearProgress() {
    const t = this.waveform_canvas.getContext("2d");
    t.globalCompositeOperation = "source-atop", t.fillStyle = this.fillColor, t.fillRect(0, 0, this.width, this.height);
  }
  clear() {
    const t = this.waveform_canvas.getContext("2d");
    t.clearRect(0, 0, this.width, this.height), t.beginPath(), t.moveTo(0, this.height / 2), t.lineTo(this.width, this.height / 2), t.stroke();
  }
}
const f = c;
export {
  f as default
};
